// Помощники видимости. Намеренно НЕ дублируют все 78 кодов прав константами: раскладка
// «роль → права» — данные администратора на сервере, а копия справочника на клиенте
// разъехалась бы молча. Здесь только сопоставление готового списка прав с реестром разделов.

import { SECTIONS, type SectionDef } from '@/app/sections';

/** Есть ли у человека право с этим кодом. Список приходит с сервера готовым. */
export function can(permissions: readonly string[], code: string): boolean {
  return permissions.includes(code);
}

/** Есть ли ХОТЬ ОДНО право из списка. Раздел виден по любому из своих. */
export function canAny(permissions: readonly string[], codes: readonly string[]): boolean {
  return codes.some((code) => can(permissions, code));
}

/** Разделы, которые видны с этим набором прав, в порядке полосы разделов. */
export function visibleSections(permissions: readonly string[]): SectionDef[] {
  return SECTIONS.filter(
    (section) =>
      canAny(permissions, section.permissions) &&
      // Второе условие — И, а не ИЛИ: раздел, который собирает данные чужими выборками, без
      // права хотя бы на одну из них открывается красной ошибкой. Причина и живой случай —
      // в комментарии к `alsoAnyOf` в `app/sections.ts`.
      (section.alsoAnyOf === undefined || canAny(permissions, section.alsoAnyOf)),
  );
}

/**
 * Представление, которое открывается по `/:section` без указания вида — ПО ПРАВАМ.
 *
 * Одного значения на раздел мало: у табельщика есть права на табель, но нет на ведомости, и
 * раздел «Расчёт», открытый на ведомостях, встретил бы его экраном отказа. Возвращается первое
 * представление, до чьего права человек дотянулся; ничего не подошло — первое из списка, чтобы
 * каркас показал честное объяснение, а не белый экран.
 */
export function defaultViewFor(section: SectionDef, permissions: readonly string[]): string {
  const доступное = section.defaultViews.find((пункт) => can(permissions, пункт.permission));
  return (доступное ?? section.defaultViews[0]!).view;
}
